const Contact = () => {
    return (
        <div className="m-8 p-6 flex justify-center space-x-4">
            <br></br>
            <p><strong><a href="https://in.linkedin.com/company/dscmakaut" target="_blank" className="hover:underline">GDSC MAKAUT linkedin</a></strong></p>
            <br></br>
            <p><strong><a href="https://gdg.community.dev/gdg-on-campus-maulana-abul-kalam-azad-university-of-technology-kalyani-india/" target="_blank" className="hover:underline">GDSC MAKAUT Official</a></strong></p>
        </div>
    );
};

export default Contact;